module.exports = __webpack_public_path__ + "img/product_toothpaste_03.be531e39.png";